export const testimonials = [
  {
    id: 1,
    name: "Lawrence Sisneros",
    rating: 5,
    review: "This gentleman came by today and he was very respectful and very professional and he did a fantastic job with my wife's challenger. He got to my house earlier to set up and get the job done in time. I definitely recommend Stefens detailing if you're in Los Lunas"
  },
  {
    id: 2,
    name: "Lleana Jaramillo",
    rating: 5,
    review: "Literally ran into Stefen while out on a run with my dog — he happened to be detailing a car just up the street! I was able to book an appointment with him right away, and he came to our house fully prepared with all the supplies. My car was in desperate need of a deep clean (so much dog hair!), and Stefen did an incredible job. He got every bit of hair out and made the outside shine, too. Highly recommend — my car hasn't looked this clean in years!"
  },
  {
    id: 3,
    name: "Begay Leland",
    rating: 5,
    review: "As advertised.. Trustworthy, reliable, very detailed work & takes the extra hour(s) to do a job well done. Had my 2017 Silverado bombed from cigarette odor previously & Stefan was able to do his own \"bomb\" & remove the odor. lol.. Great work!!"
  },
  {
    id: 4,
    name: "Rhonda Flores",
    rating: 5,
    review: "Stefen did an excellent job with the headlight restoration of my Honda CRV. The job was done in a little over an hour. Great price and trustworthy work. Im recommending Stefen to my friends for any detailing work! He also used an awesome car deodorant that I ended up buying. Nice touch Stefen! Keep up the awesome work!"
  }
];